import { QuestionExtraInfo, ReportTypes } from '@/types';
import { makeAutoObservable } from 'mobx';

interface CommonConfig {
    bookingUrl: string;
    paperReviewInfo?: ReportTypes['paperReviewInfo'];
    correctStatus?: number;
    correctStatusShow?: string; // 人工批改状态展示文案
    isOpenPersonalCorrect?: boolean;
    isDoPaper?: boolean;
    pastPaperList?: QuestionExtraInfo['pastPaperList'];
    isAllowCopy?: boolean;
    exerciseType?: number;
    isPayCorrectPaper?: boolean; // 是否付费人工批改
    paperDataLogId?: number; // 每次做试卷记录id
}

export class CommonStore {
    common: CommonConfig = {
        bookingUrl: '', // 私教预约地址， 有则展示
        isAllowCopy: false,
    };

    constructor() {
        makeAutoObservable(this);
    }

    isCurrentDateInRange(paperReviewInfo: ReportTypes['paperReviewInfo']) {
        const { isDoPaper } = paperReviewInfo;

        if (!isDoPaper) {
            return true;
        }

        const startDate = paperReviewInfo.studentSubmitStartTime;
        const endDate = paperReviewInfo!.studentSubmitEndTime;

        const currentDate = new Date();
        return currentDate >= new Date(startDate) && currentDate <= new Date(endDate);
    }

    setConfig(common: CommonConfig) {
        const { paperReviewInfo } = common;
        this.common = {
            ...this.common,
            ...common,
            isOpenPersonalCorrect: paperReviewInfo
                ? Boolean(paperReviewInfo!.autoReviewStatus) && this.isCurrentDateInRange(paperReviewInfo)
                : false,
        };
    }
}
